import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity11 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_11;
}

export default CobbledRoadTileEntity11;
